import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appLettersOnly]',
    standalone: false
})
export class LettersOnlyDirective {
	constructor(
		private el: ElementRef,
		private ngControl: NgControl
	) {}

	@HostListener('input', ['$event']) onInputChange(event: any) {
		const inputValue = event.target['value'];
		const newValue = inputValue.replace(/[^A-Za-záéíóúüñÁÉÍÓÚÜÑ\s]/g, '');

		this.el.nativeElement.value = newValue;
		this.ngControl?.control?.setValue(newValue);
	}
}
